import React from "react";

import { cn } from "../../../common/u1/cn";
import { CheckIcon, ShieldIcon, InfoIcon } from "../../../../assets/ui/icons";

/* The banner at the top of a section, in the two tones the design uses. */
const TONES = {
  done: {
    Icon: CheckIcon,
    wrapper: "border-[var(--verified-border)] bg-[var(--success-soft)]",
    mark: "text-[var(--success)]",
    tile: false,
  },
  info: {
    Icon: InfoIcon,
    wrapper: "border-[var(--claimed-border)] bg-[var(--claimed-bg)]",
    mark: "text-[var(--navy)]",
    tile: false,
  },
  offer: {
    Icon: ShieldIcon,
    wrapper: "border-[var(--verified-border)] bg-[var(--success-soft)]",
    mark: "text-[var(--success)]",
    /* The design puts the shield in its own white tile, which the tick does
       not get — it sits inline with the first line of text. */
    tile: true,
  },
};

export const SectionNotice = ({
  tone = "done",
  title,
  children,
  action,
  className = "",
}) => {
  const variant = TONES[tone] || TONES.done;
  const { Icon } = variant;

  return (
    <div
      className={cn(
        "flex flex-wrap items-start gap-3 rounded-[12px] border px-4 py-3.5",
        variant.wrapper,
        className
      )}
    >
      {/* The mark and the words are ONE flex item, so they can never be split across two lines. */}
      <div className="flex min-w-0 grow items-start gap-3">
        <span
          aria-hidden="true"
          className={cn(
            "shrink-0",
            variant.mark,
            variant.tile
              ? "flex h-9 w-9 items-center justify-center rounded-lg border border-[var(--verified-border)] bg-white"
              : "mt-[2px]"
          )}
        >
          <Icon size={variant.tile ? 17 : 14} />
        </span>

        <div className="min-w-0">
          {title && (
            <p className="m-0 text-[13px] font-bold text-[var(--ink)] font-sans">
              {title}
            </p>
          )}
          <p
            className={cn(
              "m-0 text-[12.5px] leading-[1.55] text-[var(--ink-2)] font-sans",
              title && "mt-0.5"
            )}
          >
            {children}
          </p>
        </div>
      </div>

      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
};

export default SectionNotice;
